import React from 'react';
import { motion } from 'framer-motion';
import { PathAIcon, PathBIcon } from './Icons';
export function TwoPathsSection() {
  return <section className="bg-dark-texture text-cream py-24 px-4" data-id="element-320">
      <div className="max-w-5xl mx-auto" data-id="element-321">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-322">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-323">
            Los Dos Caminos
          </h2>
          <p className="text-xl text-cream/70" data-id="element-324">
            Hoy tienes exactamente dos opciones frente a ti:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-325">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-dark-light border border-accent-red/30 p-8 rounded-xl relative overflow-hidden group" data-id="element-326">
            <div className="absolute top-0 left-0 w-full h-1 bg-accent-red/50" data-id="element-327" />
            <div className="flex items-center gap-4 mb-6" data-id="element-328">
              <PathAIcon className="w-8 h-8 text-accent-red" data-id="element-329" />
              <h3 className="text-2xl font-bold text-white" data-id="element-330">CAMINO A</h3>
            </div>
            <p className="text-accent-red/80 font-bold uppercase tracking-wider text-sm mb-4" data-id="element-331">
              Seguir como hasta ahora:
            </p>
            <p className="text-cream/70 leading-relaxed" data-id="element-332">
              Intentar conectar con Dios por tu cuenta. Luchando contra la
              distracción, la culpa y el silencio. Esperando que algo cambie
              mágicamente el próximo domingo. Cargando la religión en lugar de
              caminar con Cristo. Sabiendo mucho de Él pero sintiéndolo lejos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-olive-dark border border-gold/50 p-8 rounded-xl relative overflow-hidden shadow-[0_0_30px_rgba(197,165,90,0.1)]" data-id="element-333">
            <div className="absolute top-0 left-0 w-full h-1 bg-gold" data-id="element-334" />
            <div className="flex items-center gap-4 mb-6" data-id="element-335">
              <PathBIcon className="w-8 h-8 text-gold" data-id="element-336" />
              <h3 className="text-2xl font-bold text-white" data-id="element-337">CAMINO B</h3>
            </div>
            <p className="text-gold font-bold uppercase tracking-wider text-sm mb-4" data-id="element-338">
              Tomar el mapa:
            </p>
            <p className="text-cream/90 leading-relaxed" data-id="element-339">
              Imagina despertar mañana con la certeza de que no estás solo.
              Escuchando Su dirección con claridad en las decisiones difíciles.
              Leyendo la Biblia y sintiendo que alguien te habla a ti
              específicamente. Llevando Su Presencia al trabajo, a los
              conflictos, al descanso. Viviendo con un propósito que el mundo no
              puede quitarte.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-340">
          <p className="text-2xl md:text-3xl font-serif italic text-gold" data-id="element-341">
            "La religión terminó. El discipulado real ha comenzado."
          </p>
        </motion.div>
      </div>
    </section>;
}